import React, { useContext, useEffect, useState } from "react";
import Table from "../../../components/Table/Table";
import TraverGuideService from "../../../services/TraverGuideService";
import LangContext from "../../../context/LanguageContext";
import { Modal } from "antd";
import TabAddTravelGuide from "./TabAddTravelGuide";

const tableHeaders = [
  {
    id: 1,
    title: "travel_guide_title",
  },
  {
    id: 2,
    title: "travel_guide_description",
    html: true,
  },
];

const TabViewTravelGuide = () => {
  const initialModal = {
    type: "",
    item_id: "",
    isOpen: false,
  };
  const { lang_id } = useContext(LangContext);
  const [data, setData] = useState([]);
  const [modal, setModal] = useState<{
    type: string;
    isOpen: boolean;
    item_id: string;
  }>(initialModal);
  console.log(modal);

  const handleModal = (actionType: string, type?: string, id?: string) => {
    if (actionType === "open" && type && id) {
      setModal({
        type: type,
        item_id: id,
        isOpen: true,
      });
    } else {
      setModal(initialModal);
    }
  };
  const handleEditModal = (id: string) => {
    handleModal("open", "edit", id);
  };
  const handleDeleteModal = (id: string) => {
    handleModal("open", "delete", id);
  };
  const actionProps = {
    handleEdit: handleEditModal,
    handleDelete: handleDeleteModal,
  };

  useEffect(() => {
    if (lang_id) {
      TraverGuideService.getAllTravelGuides(`?lang=${lang_id}`)
        .then((res) => {
          setData(res.data.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [lang_id]);

  return (
    <div>
      <Table
        tableHeaders={tableHeaders}
        tableBody={data}
        actions={actionProps}
      />

      {/* edit modal   */}
      {modal.type === "edit" && modal.isOpen ? (
        <Modal
          open={modal.isOpen}
          title={null}
          keyboard
          onCancel={() => handleModal("close")}
          footer={null}
        >
          {" "}
          <div className="text-gray-500">
            <h2 className="font-bold">Edit Travel Guide</h2>
          </div>
          <TabAddTravelGuide editItemId={modal.item_id} />
          {/* <PackageTranslationForm pkgId={currentID} /> */}
        </Modal>
      ) : (
        ""
      )}
    </div>
  );
};

export default TabViewTravelGuide;
